module.exports = __webpack_public_path__ + "img/0.62a46337.png";